import type { VirtualIpVoiceWorkspace } from '../../api'

/** Canonical Step 6 voice interaction phases (selection ≠ confirmation). */
export type VoiceStep6InteractionPhase =
  | 'EMPTY'
  | 'GENERATING'
  | 'CANDIDATES_READY'
  | 'CANDIDATE_SELECTED'
  | 'CONFIRMED'

export function resolveVoiceStep6Phase(input: {
  generating: boolean
  candidatesCount: number
  selectedCandidateId: string | null
  voiceConfirmed: boolean
}): VoiceStep6InteractionPhase {
  if (input.generating) return 'GENERATING'
  if (input.voiceConfirmed) return 'CONFIRMED'
  if (input.selectedCandidateId) return 'CANDIDATE_SELECTED'
  if (input.candidatesCount > 0) return 'CANDIDATES_READY'
  return 'EMPTY'
}

/** Only the final Virtual IP workflow confirmation locks Step 6 editing. */
export function isVoiceStep6EditingLocked(input: { workflowComplete: boolean }): boolean {
  return input.workflowComplete
}

/** Transient lock while a generate request is in flight. */
export function isVoiceStep6GeneratingLocked(input: { generating: boolean }): boolean {
  return input.generating
}

export function resolveSelectedCandidateId(voice: VirtualIpVoiceWorkspace | null): string | null {
  return voice?.profile?.selected_candidate_id ?? null
}

export function canConfirmVoiceSelection(input: {
  selectedCandidateId: string | null
  voiceConfirmed: boolean
  isNoneMode: boolean
}): boolean {
  if (input.isNoneMode) return !input.voiceConfirmed
  return Boolean(input.selectedCandidateId && !input.voiceConfirmed)
}

export function voiceStep6SidebarHintKey(input: {
  voiceConfirmed: boolean
  isNoneMode: boolean
  selectedCandidateId: string | null
  canConfirm: boolean
}): string | null {
  if (input.voiceConfirmed) return 'step6.sidebar.voiceConfirmed'
  if (input.isNoneMode && !input.canConfirm) return 'step6.sidebar.confirmNone'
  if (input.selectedCandidateId) return 'step6.sidebar.voiceSelected'
  if (!input.isNoneMode) return 'step6.sidebar.selectVoiceFirst'
  return null
}

/** @deprecated Use voiceStep6SidebarHintKey with i18n at render time. */
export function voiceStep6SidebarHint(input: {
  voiceConfirmed: boolean
  isNoneMode: boolean
  selectedCandidateId: string | null
  canConfirm: boolean
}): string | null {
  return voiceStep6SidebarHintKey(input)
}
